module.exports = __webpack_public_path__ + "img/language-light.dd65e165.svg";